module.exports = __webpack_public_path__ + "img/turbo_off.94e196dd.svg";